





































import Vue from "vue";

export default Vue.extend({
  name: "UserSubInfoColumn",
  data() {
    return {};
  },
  props: {
    content: {
      type: String
    },
    color: {
      type: String,
      default: "primary"
    },
    icon: {
      type: String,
      default: "award"
    },
    link: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    transform_source(icon: HTMLElement): HTMLElement {
      for (let node of icon.children)
        node.setAttribute("fill", !this.content ? "#FF4066" : this.color);
      return icon;
    }
  }
});
